import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/developer/demos/generalised-analytics")({
    beforeLoad: () => {
        throw redirect({ to: "/design/features/generalised-analytics", replace: true });
    },
});
